<template>
  <div>
    <div class="bg-white p-8 pb-28">
      <h2>Send Screen</h2>

      <div class="screen-grid">
        <OtpSendScreen
          mobileLastFour="3456"
          :onSendCode="sendCodeWithDelay"
          class="text-center"
        />

        <OtpSendScreen
          ref="sendLoading"
          mobileLastFour="3456"
          :onSendCode="sendCodeWithDelay"
          class="text-center"
        />

        <OtpSendScreen
          ref="sendError"
          mobileLastFour="3456"
          error="server_errors.otp.generated_too_recently"
          :onSendCode="sendCodeWithDelay"
          class="text-center"
        />
      </div>

      <h2 class="mt-16">Entry Screen</h2>

      <div class="screen-grid">
        <OtpEntryScreen
          mobileLastFour="3456"
          :expires="expiryTime"
          :error="false"
          :codesSent="1"
          :verifyOtp="verifyOtpWithDelay"
          :sendCode="sendCodeWithDelay"
          class="text-center"
        />

        <OtpEntryScreen
          ref="entryLoading"
          mobileLastFour="3456"
          :expires="expiryTime"
          :error="false"
          :codesSent="3"
          :verifyOtp="verifyOtpWithDelay"
          class="text-center"
        />

        <OtpEntryScreen
          ref="entryError"
          mobileLastFour="3456"
          :expires="expiryTime"
          verifyError="otp.codeIncorrect"
          :codesSent="1"
          :verifyOtp="verifyOtpWithDelay"
          class="text-center"
        />

        <OtpEntryScreen
          ref="entryExpired"
          mobileLastFour="3456"
          requestError="otp.rateLimitExceeded"
          :expires="expiresSoon"
          :codesSent="1"
          :verifyOtp="verifyOtpWithDelay"
          :customisedBranding="true"
          class="text-center"
        />

        <OtpEntryScreen
          ref="entryResent"
          mobileLastFour="3456"
          requestError="server_errors.otp.generated_too_recently"
          :expires="expiryTime"
          :codesSent="1"
          :verifyOtp="verifyOtpWithDelay"
          :customisedBranding="true"
          class="text-center"
        />

        <OtpEntryScreen
          ref="entryLoading2"
          mobileLastFour="3456"
          :expires="expiryTime"
          :error="false"
          :codesSent="3"
          :verifyOtp="verifyOtpWithDelay"
          :customisedBranding="true"
          class="text-center"
        />
      </div>
    </div>

    <OtpScreen class="mb-28" />

    <OtpScreen
      :branding="{
        colours: {
          primary: '#f012be',
          primaryIsWhite: false,
          accentPrimary: '#7E10C1',
          accentSecondary: '#ffffff'
        },
        logo: logoWide,
        customisedBranding: true
      }"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import store from '@/store'

import OtpScreen from '@/components/screens/OtpScreen'
import OtpSendScreen from '@/components/screens/OtpSendScreen'
import OtpEntryScreen from '@/components/screens/OtpEntryScreen'
import logoWide from '@/assets/designs/logo-wide.png'

const sendLoading = ref(null)
const entryResent = ref(null)
const entryLoading = ref(null)
const entryLoading2 = ref(null)
const entryError = ref(null)

const expiresSoon = ref(new Date())
const date = new Date()
const expiryTime = ref(new Date(date.setMinutes(date.getMinutes() + 10)))

function sendCodeWithDelay () {
  return new Promise((resolve) => {
    setTimeout(() => {
      const date = new Date()
      expiryTime.value = new Date(date.setMinutes(date.getMinutes() + 10))
      resolve(true)
    }, 2000) // 2-second delay
  })
}

function verifyOtpWithDelay (otpCode) {
  console.info('verifyOtp', otpCode)

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, 2000) // 2-second delay
  })
}

onMounted(() => {
  sendLoading.value._setupProxy.sendingCode = true
  entryResent.value._setupProxy.newCodeSent = true
  entryLoading.value._setupProxy.verifyingOtp = true
  entryLoading.value._setupProxy.otpCode = '123456'
  entryLoading2.value._setupProxy.verifyingOtp = true
  entryLoading2.value._setupProxy.otpCode = '123456'
  entryError.value._setupProxy.otpCode = '987654'

  store.commit('auth/SET_OTP_SESSION', {
    mobileLastFour: '1234'
  })

  setInterval(() => {
    const date = new Date()
    expiryTime.value = new Date(date.setMinutes(date.getMinutes() + 10))
  }, 10 * 60 * 1000) // 10 minutes in milliseconds
})
</script>

<style scoped>
.screen-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(22rem, 1fr));
  gap: 2rem;
}
</style>
